import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssignedLocation, NewLocationPayload } from '../models/location.model';
import { ResidentPayload } from '../models/resident.model';
import { environment } from '../../../environments/environment';
import { GenericApiResponse } from '../models/api-response.model';

export interface ResidentSearchRequest {
  residentName?: string | null;
  mobileNumber?: string | null;
  emailAddress?: string | null;
  areaId?: string | null;
  qtrNo?: string | null;
  blockNo?: string | null;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class ManageResidentsService {

  constructor(
    private http:HttpClient,
  ) { }


  getSearchResults(postData: ResidentSearchRequest): Observable<AssignedLocation[]> {
    const url = environment.apiUrl + '/resident/v1/search';
    return this.http.post<AssignedLocation[]>(url, postData);
  }

  submitResident(postData: ResidentPayload): Observable<GenericApiResponse> {
    const url = environment.apiUrl + '/resident/v1/save';
    return this.http.post<GenericApiResponse>(url, postData);
  }

  editResident(postData: ResidentPayload): Observable<GenericApiResponse> {
    const url = environment.apiUrl + '/resident/v1/update';
    return this.http.post<GenericApiResponse>(url, postData);
  }

  addNewLocation(postData: NewLocationPayload): Observable<GenericApiResponse> {
    const url = environment.apiUrl + '/location/save';
    return this.http.post<GenericApiResponse>(url, postData);
  }
}
